import React from 'react'

export default function HowtoJoin() {
    return (
        <>
            <section className="cyber_arena pt-120 pb-120 bg5-color">
                <div className="container pt-17 pt-sm-20 pt-lg-0">
                    <div className="row">
                        <div className="cyber_arena__decs mb-8 mb-md-10">
                            <h3 className="mb-5 mb-md-6 wow fadeInUp">How To Join?</h3>
                            <div className="cyber_arena__decs-card p-4 p-sm-6 p-md-8 rounded-20 mb-5 mb-md-6 wow fadeInUp">
                                <div className="d-flex align-items-center justify-content-between flex-wrap mb-5 mb-md-6 gap-3">
                                    <h4>Connect Your Wallet</h4>
                                </div>
                                <p className="mb-6 mb-md-8">
                                    Connect your BNB Chain (BEP-20) wallet & make sure you have enough balance in USDT or ARMA token.
                                </p>
                            </div>
                            <div className="cyber_arena__decs-card p-4 p-sm-6 p-md-8 rounded-20 mb-5 mb-md-6 wow fadeInUp">
                                <div className="d-flex align-items-center justify-content-between flex-wrap mb-5 mb-md-6 gap-3">
                                    <h4>Enter Amount
                                    </h4>
                                </div>
                                <p className="mb-6 mb-md-8">Enter the amount of ARMA coins you want to buy. You will be prompted with a total purchasing amount.  </p>
                            </div>
                            <div className="cyber_arena__decs-card p-4 p-sm-6 p-md-8 rounded-20 mb-5 mb-md-6 wow fadeInUp">
                                <div className="d-flex align-items-center justify-content-between flex-wrap mb-5 mb-md-6 gap-3">
                                    <h4>Confirm Transaction
                                    </h4>
                                </div>
                                <p className="mb-6 mb-md-8">Choose either you want to pay USDT or ARMA token for the purchase & complete the transaction.
                                </p>
                            </div>
                            <div className="cyber_arena__decs-card p-4 p-sm-6 p-md-8 rounded-20 mb-5 mb-md-6 wow fadeInUp">
                                <div className="d-flex align-items-center justify-content-between flex-wrap mb-5 mb-md-6 gap-3">
                                    <h4>Receive ARMA Coin</h4>
                                </div>
                                <p className="mb-6 mb-md-8">Once the transaction is confirmed, you will subsequently receive ARMA coins in the same Aarma wallet address. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
